import api, { getJson } from "services/Api/local";

api(getJson("/config/app.json")).then(config => {
  window.__appConfig__ = config;
  import("./entry").then(() => {});
});



// WEBPACK FOOTER //
// ./src/index.js